module.exports = __webpack_public_path__ + "img/ESG_background.ded63b15.jpg";